import { useEffect } from 'react';
const useOnClickOutside = (ref, callback, conditions = []) => {
  useEffect(() => {
    const handleClick = ({
      target
    }) => {
      if (!(ref === null || ref === void 0 ? void 0 : ref.current)) {
        return;
      }
      if (ref.current !== target && !ref.current.contains(target)) {
        callback();
      }
    };
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, conditions);
};
export default useOnClickOutside;